import React from "react";
import Grid from "@cx/ui/Grid";
import Row from "@cx/ui/Row";
import Col from "@cx/ui/Col";

export default function Grids633() {
  return (
    <div>
      <Grid htmlId="FluidGridExample">
        <Row>
          <Col xs={12}>
            <h4>Fluid grid</h4>
          </Col>
        </Row>
        <Row className="show-grid">
          <Col xs={12} md={6}>
            <code>
              &lt;
              {"Col xs={12} md={6}"} /&gt;
            </code>
          </Col>
          <Col xs={12} md={3}>
            <code>
              &lt;
              {"Col xs={12} md={3}"} /&gt;
            </code>
          </Col>
          <Col xs={12} md={3}>
            <code>
              &lt;
              {"Col xs={12} md={3}"} /&gt;
            </code>
          </Col>
        </Row>
      </Grid>

      <Grid htmlId="FixedGridExample" fluid={false}>
        <Row>
          <Col xs={12}>
            <h4>Fixed grid</h4>
          </Col>
        </Row>
        <Row className="show-grid">
          <Col xs={12} md={6}>
            <code>
              &lt;
              {"Col xs={12} md={6}"} /&gt;
            </code>
          </Col>
          <Col xs={12} md={3}>
            <code>
              &lt;
              {"Col xs={12} md={3}"} /&gt;
            </code>
          </Col>
          <Col xs={12} md={3}>
            <code>
              &lt;
              {"Col xs={12} md={3}"} /&gt;
            </code>
          </Col>
        </Row>
      </Grid>
    </div>
  );
}
